import api from "../../../instance/api";
import {
  errorMemberSampleDownload,
  startMemberSampleDownload,
  successMemberSampleDownload,
} from "../../../slice/Sample/Member";

const downloadMemberSampleFileApi = () => async (dispatch) => {
  dispatch(startMemberSampleDownload());

  try {
    const res = await api.get(
      `sample/download?fileIdentifier=BULK_USER_SAMPLE_FILE`,
      { responseType: "blob" } // 👈 this is required
    );

    dispatch(successMemberSampleDownload());
    const blob = res.data;
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = "BULK_UPLOAD_USER.xlsx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (err) {
    dispatch(errorMemberSampleDownload(err?.response?.data?.message));
    console.log("Download error:", err);
  }
};

export { downloadMemberSampleFileApi };
